import { DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const CartHeader = () => {
  return (
    <DialogHeader>
      <DialogTitle>Panier</DialogTitle>
    </DialogHeader>
  );
};